module.exports = __webpack_public_path__ + "static/media/carl746-080.54787ae2.jpg";